module.exports = __webpack_public_path__ + "static/media/IMG_7334-Edit.a0f61300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/square/IMG_7334-Edit.jpg
// module id = 146
// module chunks = 0